import React from 'react';
import Helmet from 'react-helmet';
import SeoBlockEndCode from './SeoBlockEndCode';

const SeoBlock = ({data, contact}) => {
  const seo = data;
  const seo_base_path = window.location.origin;
  const seo_base_host = window.location.host;
  const contact_in = contact && contact.city_in;
  const title = seo && seo.seo_title && ((seo.seo_title.includes('#CITY_ROD#')) ? seo.seo_title.replace('#CITY_ROD#', contact_in ? `в ${contact_in}`: ''): seo.seo_title);
  const descr = seo && seo.seo_description && (seo.seo_description.includes('#CITY_ROD#') ? seo.seo_description.replace('#CITY_ROD#', contact_in ? `в ${contact_in}`: ''): seo.seo_description);
  const keywords = seo && seo.seo_keywords;
  const code = seo && seo.seo_code;
  
  const metatags = [
    {"name": "description", "content": `hhh ${descr}` },
    {"name": "keywords", "content": `kkk ${keywords}`}
  ]
  
  if (window.location.host.split('.').length > 2) {
    metatags.push({"name": "yandex", "content": "noindex"})
  } else if (contact && contact.slug.length > 0 && window.location.pathname.includes(contact.slug)) {
    metatags.push({"name": "googlebot", "content": "noindex, nofollow"})
  }

  const location = window.location.origin;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Брендинговое агентство Проектмаркетинг +1",
    "url": location,
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "17"
    }
  };
 
  return (<>
      <Helmet
          htmlAttributes={{"lang": "ru"}} // amp takes no value
          title={title}
          titleTemplate={` %s`}
          defaultTitle="Проектмаркетинг"
          base={{"target": "_blank", "href": {seo_base_path}}}
          meta={metatags && metatags}
      >
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>
      <SeoBlockEndCode code={code} />
      </>
  );
}

export default SeoBlock;
